"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgArrowOnboarding = function SvgArrowOnboarding(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.515 10.357a1 1 0 0 0 .343-1.372l-4.63-7.717a1 1 0 1 0-1.716 1.03l4.117 6.859-6.86 4.116a1 1 0 0 0 1.029 1.715l7.717-4.63Zm-25 19.315a1 1 0 0 0 1.97-.344l-1.97.344ZM25.243 8.53c-5.149-1.287-12.182-1.319-17.54 1.658-2.706 1.503-4.982 3.774-6.336 7.012-1.35 3.227-1.75 7.337-.852 12.472l1.97-.344c-.851-4.864-.44-8.568.727-11.356 1.161-2.778 3.104-4.726 5.461-6.035 4.767-2.648 11.233-2.68 16.085-1.467l.485-1.94Z",
    fill: "#fff"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgArrowOnboarding);
var _default = exports["default"] = Memo;